import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Button,
  Spinner
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import {Link, Navigate} from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunks";

const mediaSource = api.IMAGE_URL;
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
import {useProfile} from "../../Components/Hooks/UserHooks";
import {api} from "../../config";

const ForgetPasswordPage = props => {
  const dispatch = useDispatch();

  const [isloading, setIsloading] = useState(false);


  const [storedData, setStoredData] = useState([]);
  useEffect(() => {
    const dataFromLocalStorage = localStorage.getItem('apiData');
    setStoredData(dataFromLocalStorage ? JSON.parse(dataFromLocalStorage) : null);
  },[]);

  const { userProfile,  token } = useProfile();
  if (userProfile  && token) {
    return (
        <Navigate to={{ pathname: "/admin/dashboard", state: { from: props.location } }} />
    );
  }



  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      setIsloading(true);
      dispatch(userForgetPassword(values, props.history));
    }
  });


  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
      isSent: state.isSent,
    })
  );
  // Inside your component
  const {
    forgetError, forgetSuccessMsg,isSent
  } = useSelector(selectLayoutProperties);

  useEffect(() => {
    if(isSent){
      setIsloading(false);
    }
    forgetError? setIsloading(false):null
  }, [forgetError,forgetSuccessMsg,isSent]);

  document.title = "Reset Password |Theory Practice";
  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5">

        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={storedData && mediaSource + storedData.logo} alt="" height="75"/>
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium"> {storedData && storedData.title} </p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">

                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Forgot Password?</h5>
                    <p className="text-muted">Reset password with {storedData && storedData.title} </p>

                    <lord-icon
                        src="https://cdn.lordicon.com/rhvddzym.json"
                        trigger="loop"
                        colors="primary:#0ab39c"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    >
                    </lord-icon>

                  </div>

                  <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    Enter your email and instructions will be sent to you!
                  </Alert>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <Button color="success" disabled={isloading ? true : false} className="btn btn-success w-100" type="submit">
                            {isloading ?  <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>: null}
                              <span className="flex-grow-1 ms-2">
                              Send Reset Link
                               </span>
                        </Button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link> </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
